export default {
  brand: {
    name: "Basetao Sheet",
    tagline: "O centro de recursos Basetao",
  },
  nav: {
    spreadsheet: "Planilha",
    reviews: "Avaliações",
    shipping: "Envio",
    coupons: "Cupons",
    warehouse: "Armazém",
    qc: "QC",
    guides: "Guias",
    safety: "Segurança",
    cta: "Explorar a planilha",
    home: "Início",
    shoppingGuide: "Guia de compras",
  },
  lang: {
    label: "Idioma",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  categories: {
    title: "Comprar por categoria",
    dropdownLabel: "Navegar pelas categorias",
    browseCta: "Ver todas as categorias",
    shoes: "Tênis",
    hoodies: "Moletons / Suéteres",
    tshirts: "Camisetas",
    jackets: "Jaquetas",
    pants: "Calças / Shorts",
    headwear: "Acessórios de cabeça",
    sets: "Conjuntos",
    underwear: "Roupas íntimas / Cuecas",
    jersey: "Camisa",
    accessories: "Acessórios",
    bags: "Bolsas",
    belts: "Cintos",
    perfumes: "Perfumes",
    other: "Outros itens",
  },
  hero: {
    eyebrow: "O CENTRO DE RECURSOS BASETAO",
    title: "Basetao Spreadsheet — Encontre produtos, vendedores, QC e envio mais rápido",
    subtitle:
      "Explore o Basetao Spreadsheet: recursos de produtos organizados, guias de vendedores, informações de QC, guias de envio, dicas de armazém, avaliações e recursos de compra práticos — tudo em um só lugar.",
    primaryCta: "Basetao Spreadsheet",
    secondaryCta: "Comprar agora",
    trust: "Recurso independente • Atualizado regularmente • Amigável para iniciantes",
  },
  what: {
    title: "O que é um Basetao Spreadsheet?",
    subtitle:
      "Um Basetao Spreadsheet é uma forma estruturada de organizar e descobrir informações de produtos, vendedores, links e recursos de compra. Ele torna a pesquisa de produtos mais rápida e fácil de navegar.",
    card1Title: "Encontrar produtos",
    card1Desc: "Descubra recursos de produtos organizados.",
    card2Title: "Pesquisar vendedores",
    card2Desc: "Revise as informações do vendedor rapidamente.",
    card3Title: "Verificar QC",
    card3Desc: "Entenda os detalhes do controle de qualidade.",
    card4Title: "Comparar envio",
    card4Desc: "Entenda claramente as variáveis de envio.",
    cta: "Explorar o Basetao Spreadsheet",
  },
  popular: {
    title: "Buscas populares",
    subtitle: "Os temas mais procurados pelos compradores da Basetao.",
    items: [
      "Basetao Spreadsheet",
      "Avaliação Basetao",
      "Custo de envio Basetao",
      "Cupom Basetao",
      "Código de desconto Basetao",
      "Armazém Basetao",
      "A Basetao é legítima?",
      "QC Basetao",
    ],
  },
  why: {
    title: "Por que usar este site?",
    subtitle: "Feito para deixar sua pesquisa da Basetao mais clara e rápida.",
    items: [
      { title: "Organizado", desc: "Tudo estruturado em um lugar claro." },
      { title: "Prático", desc: "Focado em decisões de compra reais." },
      { title: "Transparente", desc: "Explicamos limites e incertezas abertamente." },
      { title: "Multilíngue", desc: "Disponível em cinco idiomas." },
    ],
  },
  how: {
    title: "Como funciona",
    subtitle: "Um fluxo de pesquisa simples, da descoberta ao pagamento.",
    steps: [
      { title: "Encontrar", desc: "Navegue por recursos de produtos e vendedores." },
      { title: "Pesquisar", desc: "Revise anúncios, vendedores e links." },
      { title: "Comparar", desc: "Pondere QC, envio e preço." },
      { title: "Verificar", desc: "Confira notas de segurança e sinais de alerta." },
      { title: "Continuar", desc: "Vá ao site principal para comprar." },
    ],
  },
  safety: {
    title: "Nota de segurança importante",
    text:
      "Anúncios, vendedores, custos de envio e promoções podem mudar. Guias e planilhas organizam as informações, mas não podem garantir a qualidade do produto, a confiabilidade do vendedor nem os resultados de entrega.",
    links: [
      "Segurança do vendedor",
      "Guia de QC",
      "Risco de envio",
      "Segurança de pagamento",
      "A Basetao é legítima?",
    ],
  },
  faq: {
    title: "Perguntas frequentes",
    items: [
      {
        q: "O que é um Basetao Spreadsheet?",
        a: "É um documento estruturado que organiza produtos, vendedores, preços, fotos QC e detalhes de envio em um só lugar, facilitando a pesquisa.",
      },
      {
        q: "Como funciona um Basetao Spreadsheet?",
        a: "Ele agrupa informações úteis em colunas e categorias para encontrar, comparar e acompanhar itens mais rápido do que rolando mensagens dispersas.",
      },
      {
        q: "A Basetao é legítima?",
        a: "A Basetao é um agente de compras usado há muito tempo por muitos compradores internacionais. Este site é independente: verifique sempre você mesmo vendedores e pedidos.",
      },
      {
        q: "Quanto custa o envio da Basetao?",
        a: "O custo depende de peso, dimensões, destino, método e seguro. Consulte o guia de envio do site principal para as tarifas atuais.",
      },
      {
        q: "Onde encontro cupons da Basetao?",
        a: "As promoções mudam com frequência. Procure ofertas verificadas e atuais em vez de códigos expirados de outros lugares.",
      },
    ],
  },
  finalCta: {
    title: "Pronto para explorar o Basetao Spreadsheet?",
    subtitle: "Navegue por produtos, vendedores e recursos organizados no site principal.",
    button: "Explorar o Basetao Spreadsheet",
  },
  guides: {
    title: "Guias e recursos Basetao",
    subtitle:
      "Artigos essenciais que cobrem a planilha, avaliações, envio, cupons, armazém e segurança.",
    readMore: "Ler artigo",
  },
  footer: {
    description:
      "Um recurso informativo independente sobre o Basetao Spreadsheet. Não afiliado nem endossado pela Basetao.",
    resources: "Recursos",
    about: "Sobre",
    contact: "Contato",
    privacy: "Privacidade",
    terms: "Termos",
    disclaimer: "Aviso legal",
    cookie: "Política de cookies",
    languages: "Idiomas",
    copyright: "© 2026 Basetao Sheet. Todos os direitos reservados.",
  },
  article: {
    breadcrumb: "Início › Guias",
    h1: "Basetao Spreadsheet: o guia completo de produtos, vendedores, QC e envio",
    updated: "Última atualização: 19 de agosto de 2026",
    quickAnswerLabel: "Resposta rápida",
    quickAnswer:
      "Um Basetao Spreadsheet é um documento estruturado e compartilhado que organiza produtos, vendedores, preços, fotos QC e detalhes de envio em um só lugar. Ele ajuda a encontrar itens mais rápido, comparar vendedores e acompanhar pedidos — muito mais fácil do que rolar mensagens dispersas.",
    tocTitle: "Índice",
    sections: [
      {
        title: "O que é um Basetao Spreadsheet?",
        body: [
          "Um Basetao Spreadsheet é, essencialmente, uma tabela compartilhada que reúne tudo o que um comprador precisa para pesquisar uma compra. Em vez de vasculhar o histórico de chat, álbuns de vendedores ou favoritos, você encontra nomes de produtos, imagens, detalhes do vendedor, preços, status de QC e notas de envio em colunas claras.",
          "Essa organização é especialmente útil quando você compara muitos itens ao mesmo tempo. A planilha funciona como uma única fonte que você pode escanear rapidamente, economizando tempo e reduzindo o risco de confundir produtos parecidos de vendedores diferentes.",
        ],
      },
      {
        title: "Por que os compradores usam um Basetao Spreadsheet",
        body: [
          "O principal motivo é a velocidade. Quando a pesquisa é estruturada, você passa menos tempo procurando e mais tempo decidindo. Uma planilha também guarda um registro do que você encontrou, pediu e ainda precisa verificar.",
          "Para pedidos grandes ou compras repetidas, uma planilha ajuda a manter a consistência. Você acompanha vendedores de confiança, anota quais itens passaram no controle de qualidade e lembra opções de envio que funcionaram bem antes.",
        ],
      },
      {
        title: "Como um Basetao Spreadsheet é organizado",
        body: [
          "Uma planilha típica agrupa as informações em algumas colunas principais: nome do produto, imagem, categoria, vendedor, preço, status de QC e um link para o item. Algumas também incluem peso de envio, notas de armazém e observações pessoais.",
          "As categorias costumam refletir a estrutura da loja — tênis, moletons, camisetas, jaquetas, calças, acessórios de cabeça, conjuntos, roupas íntimas, camisas, acessórios, bolsas, cintos, perfumes e outros itens. Isso permite ir direto à seção de seu interesse.",
        ],
      },
      {
        title: "Como encontrar produtos com um Basetao Spreadsheet",
        body: [
          "Comece pela categoria de seu interesse e escaneie os nomes e imagens em busca de itens que combinem. Use as colunas de vendedor e preço para afunilar suas opções.",
          "Assim que notar um item promissor, abra o link no site principal para ver os detalhes completos, a disponibilidade e as ofertas atuais. A planilha é o ponto de partida — o anúncio em si é onde você confirma os detalhes.",
        ],
      },
      {
        title: "Como pesquisar vendedores",
        body: [
          "Pesquisar vendedores importa porque a qualidade e a confiabilidade variam. Observe se um vendedor aparece de forma consistente, como seus produtos são descritos e se notas de QC anteriores indicam problemas recorrentes.",
          "Trate as informações do vendedor como um primeiro sinal, não uma garantia. As condições mudam: verifique cada vendedor a cada pedido, especialmente em itens de maior valor.",
        ],
      },
      {
        title: "Entendendo as fotos QC",
        body: [
          "As fotos QC (controle de qualidade) são uma das partes mais valiosas do processo de compra. Elas mostram o item real antes do envio, para detectar cedo problemas de tamanho, cor ou defeito.",
          "Ao revisar fotos QC, compare-as com o anúncio original. Preste atenção em costuras, logotipos, cores e medidas. Se algo parecer estranho, pergunte antes de o item ser enviado.",
        ],
      },
      {
        title: "Custos e opções de envio",
        body: [
          "O custo de envio não é um número fixo — depende do peso do pacote, dimensões, país de destino, método escolhido e seguro. Pacotes mais pesados ou volumosos costumam custar mais.",
          "Diferentes linhas de envio equilibram velocidade e preço. Algumas são mais rápidas, porém mais caras, outras mais baratas, porém mais lentas. A escolha certa depende de quão rápido você precisa do pacote e de quanto quer gastar.",
        ],
      },
      {
        title: "Erros comuns a evitar",
        body: [
          "Um erro frequente é pedir antes de revisar as fotos QC, o que dificulta resolver problemas. Outro é ignorar o peso ao planejar o envio, o que pode gerar uma conta inesperadamente alta.",
          "Também é fácil confundir itens parecidos de vendedores diferentes. Usar a planilha para anotar qual item veio de qual vendedor evita confusões e mantém os pedidos organizados.",
        ],
      },
      {
        title: "Segurança e sinais de alerta",
        body: [
          "Mantenha uma precaução saudável. Desconfie de vendedores sem histórico, preços bons demais para ser verdade ou anúncios que reutilizam fotos sem relação. Pequenos depósitos ou pedidos de pagamento incomuns também podem ser sinais de alerta.",
          "Este site é um recurso independente: verifique sempre as informações por conta própria. Nenhum guia pode garantir qualidade do produto, confiabilidade do vendedor ou resultados de entrega. Use estes recursos como um ponto de partida útil, não como substituto do seu próprio julgamento.",
        ],
      },
    ],
    tableTitle: "Planilha vs. anotações dispersas",
    tableHeaders: ["Recurso", "Basetao Spreadsheet", "Anotações manuais"],
    tableRows: [
      ["Descoberta de produtos", "Organizada e filtrável", "Difícil de buscar"],
      ["Pesquisa de vendedores", "Colunas estruturadas", "Mensagens dispersas"],
      ["Acompanhamento de QC", "Campos de QC dedicados", "Misturado ao chat"],
      ["Planejamento de envio", "Claro de relance", "Exige vasculhar"],
      ["Ideal para", "Pesquisadores sérios", "Navegação ocasional"],
    ],
    faqTitle: "Perguntas frequentes",
    faqs: [
      {
        q: "Um Basetao Spreadsheet é gratuito?",
        a: "As planilhas costumam ser recursos compartilhados. Consulte o site principal para a versão atual e detalhes de acesso.",
      },
      {
        q: "Com que frequência a planilha é atualizada?",
        a: "As atualizações variam. Anúncios, vendedores e preços mudam: trate as informações como um instantâneo e confirme os detalhes no site principal antes de pedir.",
      },
      {
        q: "Posso usar a planilha no celular?",
        a: "A maioria dos documentos estruturados funciona no desktop e no celular. Para comparar muitas colunas, uma tela maior costuma ser mais confortável.",
      },
      {
        q: "A planilha garante a qualidade do produto?",
        a: "Não. Ela organiza as informações, mas não pode garantir qualidade, confiabilidade do vendedor ou resultados de entrega. Revise sempre as fotos QC e faça suas próprias verificações.",
      },
    ],
    conclusion:
      "Um Basetao Spreadsheet é uma ferramenta prática para quem quer pesquisar produtos, vendedores, QC e envio de forma mais eficiente. Ele reúne informações dispersas em uma visão clara, para decisões melhores e menos tempo perdido procurando. Lembre-se de que os detalhes mudam: use a planilha como guia e confirme sempre as informações mais recentes no site principal antes de comprar.",
    relatedTitle: "Recursos relacionados",
    backHome: "Voltar ao início",
    ctaLabel: "Explorar o Basetao Spreadsheet",
    conclusionTitle: "Conclusão",
    readGuide: "Ler o guia",
    toc: [
      "O que é um Basetao Spreadsheet?",
      "Por que os compradores usam um Basetao Spreadsheet",
      "Como um Basetao Spreadsheet é organizado",
      "Como encontrar produtos",
      "Como pesquisar vendedores",
      "Entendendo as fotos QC",
      "Custos e opções de envio",
      "Erros comuns a evitar",
      "Segurança e sinais de alerta",
    ],
  },
};